import { useEffect } from "react";
import { Switch, Route } from "react-router-dom";
import { StartPage } from "../../pages/StartPage";
import { TaskpanePage } from "../../pages/TaskpanePage";
import { AttachFilesPage } from "../../pages/AttachFilesPage";
import { SelectFolderPage } from "../../pages/SelectFolderPage";
import { restoreConsoleLogging } from "../../logger/remote_logger";

export const App = () => {
  useEffect(() => {
    return () => {
      restoreConsoleLogging();
    };
  }, []);
  return (
    <Switch>
      <Route exact path="/start">
        <StartPage />
      </Route>
      <Route path="/selectFolder/:matterId">
        <SelectFolderPage />
      </Route>
      <Route path="/attachFiles/:matterId">
        <AttachFilesPage />
      </Route>
      {/* leave this at the bottom as a default root */}
      <Route path="/read">
        <TaskpanePage route="read" />
      </Route>
      <Route path="/compose">
        <TaskpanePage route="compose" />
      </Route>
      <Route path="/">
        <TaskpanePage route="default" />
      </Route>
    </Switch>
  );
};
